// CapacityFilter.js - Improved version

import { useState } from "react";
import { Checkbox } from "reusableComponents";
import { FiltersButton } from "..";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

const CapacityFilter = ({
  filters,
  selectedCapacity = null,
  onCapacityChange,
  capacityOptions,
}) => {
  const [t] = useTranslation("global");
  const [showCapacityDropdown, setShowCapacityDropdown] = useState(true);

  const toggleShowCapacityDropdown = () => {
    setShowCapacityDropdown((prevState) => !prevState);
  };

  const handleCapacityChange = (option) => {
    // Set the selected capacity directly to the onCapacityChange callback
    onCapacityChange(option.value);
    
    // Close the accordion after selection
    setShowCapacityDropdown(false);
  };

  return (
    <div className={styles.capacityFilterWrapper}>
      <FiltersButton
        label={
          selectedCapacity
            ? `${selectedCapacity}`
            : t("space.persons")
        }
        isActive={!!selectedCapacity}
        onClick={toggleShowCapacityDropdown}
      />
      <div
        className={`${styles.capacityDropdownBody} ${
          showCapacityDropdown ? styles.visible : styles.hidden
        }`}
      >
        {capacityOptions.map((option) => (
          <div 
            key={option.value} 
            className={styles.capacityOption}
            onClick={() => handleCapacityChange(option)}
          >
            <Checkbox
              checked={selectedCapacity === option.value}
              onChange={() => {}} // Empty function since we're handling click on the div
              label={option.label}
              greyText={true}
              readOnly
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CapacityFilter;